import React, { useEffect } from 'react';
import Logo from './Logo';

const Splash = () => {
  useEffect(() => {
    // Mark that initial app splash is active so pages don't show their own loader on top
    window.__appSplashActive = true;

    // The Splash animation/fade-out lasts ~1.5s (matches CSS animation above)
    const t = setTimeout(() => {
      window.__appSplashActive = false;
    }, 1600);

    return () => {
      clearTimeout(t);
      window.__appSplashActive = false;
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-white z-50 flex items-center justify-center animate-[fade-out_0.5s_ease-in-out_1.5s_forwards]">
      <div className="animate-fade-in">
        {/* simple fade in, no complex animations */}
        <Logo size="xlarge" />
      </div>
    </div>
  );
};

export default Splash;
